import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import listPlugin from "@fullcalendar/list";

import { Container, DialogContent } from "@mui/material";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";

import MenuItem from "@mui/material/MenuItem";
import LoadingButton from "@mui/lab/LoadingButton";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import "./Signup.css";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

import List from "@mui/material/List";
import PeriodListItem from "../../components/PeriodListItem";

import {
  getDateActivities,
  getDayForStudent,
  getSelectedActivityFromResult,
  saveStudentDay,
} from "../../services/ActivityService";
import {
  getSchoolStatus,
  getPeriodName,
  getPeriodSingleName,
} from "../../services/SchoolService";
import { getCalendarStatus } from "../../services/UserService";
import {
  getDay,
  getMD,
  getMMDD,
  getYYYYMMDD,
  parseYYYYMMDD,
  getToday,
  getDifferenceInDays,
} from "../../services/DateService";

import clone from "lodash-es/clone";
import truncate from "lodash-es/truncate";

import { isStringEmpty } from "../../services/StringService";
import { isMobile } from "react-device-detect";

import { showError, showToast } from "../../components/ATPDialogs";

const Signup = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);

  const [_schoolStatus, setSchoolStatus] = useState({});
  const [_hasValidCutoff, setValidCutoff] = useState(false);

  const [_cutoffDateText, setCutoffDateText] = useState("");
  const [_cutoffTimeText, setCutoffTimeText] = useState("soon");

  const [_calendarEvents, setCalendarEvents] = useState([]);
  const [_status, setStatus] = useState({});

  const [_mSelectedDate, setMSelectedDate] = useState(dayjs());

  const [_backDropOpen, setBackDropOpen] = useState(false);

  const [_dialogOpen, setDialogOpen] = useState(false);
  const [_detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [_dialogDate, setDialogDate] = useState("");

  const [_calendarRatio, setCalendarRatio] = useState(0.84);
  const [_detailActivity, setDetailActivity] = useState({});
  const [_detailActivityPeriod, setDetailActivityPeriod] = useState(1);
  const [_categories, setCategories] = useState([]);
  const [_selectedCategoryEid, setSelectedCategoryEid] = useState("XX");
  const [_disabledDaysMap, setDisabledDaysMap] = useState({});

  const [_tags, setTags] = useState([]);
  const [_selectedTagEid, setSelectedTagEid] = useState("XX");

  const MAX_ACTIVITY_COUNT = 20;

  const [_allPeriodActivities, setAllPeriodActivities] = useState({
    period1: [],
    period2: [],
    period3: [],
    period4: [],
    period5: [],
    period6: [],
    period7: [],
    period8: [],
    period9: [],
    period10: [],
    period11: [],
    period12: [],
    period13: [],
    period14: [],
    period15: [],
    period16: [],
    period17: [],
    period18: [],
    period19: [],
    period20: [],
  });

  const [_filteredPeriodActivities, setFilteredPeriodActivities] = useState({
    period1: [],
    period2: [],
    period3: [],
    period4: [],
    period5: [],
    period6: [],
    period7: [],
    period8: [],
    period9: [],
    period10: [],
    period11: [],
    period12: [],
    period13: [],
    period14: [],
    period15: [],
    period16: [],
    period17: [],
    period18: [],
    period19: [],
    period20: [],
  });

  const getEmptySelectedActivity = () => {
    return { activityDateEid: "XX" };
  };

  const [_selectedActivities, setSelectedActivities] = useState({
    period1: getEmptySelectedActivity(),
    period2: getEmptySelectedActivity(),
    period3: getEmptySelectedActivity(),
    period4: getEmptySelectedActivity(),
    period5: getEmptySelectedActivity(),
    period6: getEmptySelectedActivity(),
    period7: getEmptySelectedActivity(),
    period8: getEmptySelectedActivity(),
    period9: getEmptySelectedActivity(),
    period10: getEmptySelectedActivity(),
    period11: getEmptySelectedActivity(),
    period12: getEmptySelectedActivity(),
    period13: getEmptySelectedActivity(),
    period14: getEmptySelectedActivity(),
    period15: getEmptySelectedActivity(),
    period16: getEmptySelectedActivity(),
    period17: getEmptySelectedActivity(),
    period18: getEmptySelectedActivity(),
    period19: getEmptySelectedActivity(),
    period20: getEmptySelectedActivity(),
  });
  const [_originalSelectedActivities, setOriginalSelectedActivities] = useState(
    {
      period1: getEmptySelectedActivity(),
      period2: getEmptySelectedActivity(),
      period3: getEmptySelectedActivity(),
      period4: getEmptySelectedActivity(),
      period5: getEmptySelectedActivity(),
      period6: getEmptySelectedActivity(),
      period7: getEmptySelectedActivity(),
      period8: getEmptySelectedActivity(),
      period9: getEmptySelectedActivity(),
      period10: getEmptySelectedActivity(),
      period11: getEmptySelectedActivity(),
      period12: getEmptySelectedActivity(),
      period13: getEmptySelectedActivity(),
      period14: getEmptySelectedActivity(),
      period15: getEmptySelectedActivity(),
      period16: getEmptySelectedActivity(),
      period17: getEmptySelectedActivity(),
      period18: getEmptySelectedActivity(),
      period19: getEmptySelectedActivity(),
      period20: getEmptySelectedActivity(),
    },
  );

  const calendarRef = React.createRef();
  const [_originalActivityHash, setOriginalActivityHash] = useState("");
  const [_loadedDates, setLoadedDates] = useState({});
  const [_dayActivityCount, setDayActivityCount] = useState(0);

  const evalCutoffDate = (statusObj) => {
    if (statusObj.cutoffEnabled === "N") {
      setValidCutoff(false);
      return false;
    }

    // if yes then evaluate
    if (
      statusObj.selectCutoffDate != null &&
      statusObj.selectCutoffDate !== "" &&
      statusObj.selectCutoffDate !== "2045-06-16"
    ) {
      setCutoffDateText(statusObj.selectCutoffDate);
      setValidCutoff(true);
      return true;
    }

    if (statusObj.selectDaysAhead < 180) {
      const mDate = dayjs().add(statusObj.selectDaysAhead, "days");
      setCutoffDateText(getYYYYMMDD(mDate));
      setValidCutoff(true);
      return true;
    }

    return false;
  };

  const evalCutoffTime = (statusObj) => {
    if (statusObj.activityCutoffTime == null) {
      return "soon.";
    }

    let time = statusObj.activityCutoffTime + "";

    let hour = 0;

    if (time.length === 3) {
      time = time.substring(0, 1) + ":" + time.substring(1, 3);
    } else {
      hour = parseInt(time.substring(0, 2));

      if (hour > 12) {
        time = hour - 12 + ":" + time.substring(2, 4);
      } else {
        time = time.substring(0, 2) + ":" + time.substring(2, 4);
      }
    }

    let ampm = " PM";
    if (hour < 12) {
      ampm = " AM";
    }

    let suffixDayText = "";
    let prefixDayText = "";
    if (statusObj.activityCutoffDays > 0) {
      suffixDayText = `, from previous ${statusObj.activityCutoffDays} day(s)`;
    } else {
      prefixDayText = " today at ";
    }

    setCutoffTimeText(prefixDayText + time + ampm + suffixDayText);
  };

  /**
   * retrieves calendar for the student
   */
  const initStudentCalendar = () => {
    return getCalendarStatus(_school, _jwt);
  };

  /**
   * surgically adds/removes from existing calendar object to reduce data load
   */
  const updateCalendarEvents = (values) => {
    const calendarEvents = clone(_calendarEvents);
    for (let periodNum = 1; periodNum <= _dayActivityCount; periodNum++) {
      const key = `mav${periodNum}`;
      const activityDateEid = values[key];

      // if student did not select, deselected
      if (isMobile) {
        // decrement number
      } else {
        // code below is for desktop, where we show the activity name in the calendar
        for (const calendarEvent of calendarEvents) {
          console.log(calendarEvent);
        }
      }

      // remove any previous entry for that particular item for date/period
      const index = calendarEvents.findIndex(
        (event) => event.start === values.date && event.period === periodNum,
      );
      if (index !== -1) {
        calendarEvents.splice(index, 1);
      }

      // if the student selected an activity for this period, then add it to the calendar
      if (activityDateEid !== "" && activityDateEid !== null) {
        const loadedActivityDetails = _loadedDates[values.date][
          `period${periodNum}`
        ].find((activity) => activity.activityDateEid === activityDateEid);

        calendarEvents.push({
          title: isMobile
            ? "✅"
            : getPeriodSingleName(_school, periodNum - 1) +
              ": " +
              truncate(loadedActivityDetails.name, { length: 16 }),
          start: values.date,
          period: periodNum,
        });
      }
    }
    setCalendarEvents(calendarEvents);

    const loadedDate = _loadedDates[values.date];

    // return getCalendarStatus(_school, _jwt);
  };

  const sortActivitiesWithZeroAtBottom = (activitiesByPeriod) => {
    if (!activitiesByPeriod || typeof activitiesByPeriod !== "object") {
      return activitiesByPeriod;
    }

    const sortedActivities = {};
    Object.entries(activitiesByPeriod).forEach(([key, value]) => {
      if (!Array.isArray(value)) {
        sortedActivities[key] = value;
        return;
      }

      sortedActivities[key] = [...value].sort((a, b) => {
        const aLeft = Number(a?.left ?? 0);
        const bLeft = Number(b?.left ?? 0);

        if (aLeft === 0 && bLeft !== 0) return 1;
        if (aLeft !== 0 && bLeft === 0) return -1;
        return 0;
      });
    });

    return sortedActivities;
  };

  const loadDateEvents = async (activities, disabledDaysMap) => {
    const events = [];
    if (isMobile) {
      // key: date, value: count
      const counts = {};
      // count up and display just the count
      for (let i = 0; i < activities.length; i++) {
        if (counts[activities[i].date]) {
          counts[activities[i].date] += 1;
        } else {
          counts[activities[i].date] = 1;
        }
      }

      for (const date in counts) {
        const event = {
          title: "✅",
          start: date,
          mobileCount: counts[date],
        };
        events.push(event);
      }
    } else {
      // show short label
      for (let i = 0; i < activities.length; i++) {
        const periodNumber = activities[i].period;
        const event = {
          title:
            getPeriodSingleName(_school, periodNumber - 1) +
            ": " +
            truncate(activities[i].name, { length: 16 }),
          start: activities[i].date,
          period: activities[i].period,
        };
        events.push(event);
      }
    }

    setCalendarEvents(events);
  };

  useEffect(() => {
    setDayActivityCount(_school.maxActivityCount);
    if (isMobile) {
      setCalendarRatio(0.84);
    } else {
      setCalendarRatio(1.66);
    }

    initContent();
  }, [_school]);

  const initContent = () => {
    setBackDropOpen(true);
    setShowProgress(true);
    const promises = [getSchoolStatus(_school, _jwt), initStudentCalendar()];

    Promise.all(promises)
      .then((results) => {
        let result = results[0];
        let data = result.data;
        setStatus(data);
        setSchoolStatus(data);
        setTags(data.tags);
        evalCutoffDate(data);
        evalCutoffTime(data);
        const disabledDaysMap = evalDisabledDays(data.excludedDates);

        setCategories(data.categories);
        handleChangeCategory(null);

        result = results[1];
        loadDateEvents(result.data, disabledDaysMap);
      })
      .finally(() => {
        setShowProgress(false);
        setBackDropOpen(false);
      });
  };

  const evalDisabledDays = (dates) => {
    cssDisabledDays(dates);
    const disabledDaysMap = {};
    for (let date of dates) {
      disabledDaysMap[date.date] = date;
    }
    setDisabledDaysMap(disabledDaysMap);
    return disabledDaysMap;
  };

  const cssDisabledDays = (disabledDates) => {
    for (let date of disabledDates) {
      let res = document.querySelectorAll(`[data-date="${date.date}"]`);
      if (res != null && res.length > 0) {
        res[0].style.backgroundColor = "#dfdfdf";
        let textRes = res[0].querySelectorAll(
          `[class="fc-daygrid-day-events"]`,
        );
        if (textRes != null && textRes.length > 0) {
          textRes[0].innerHTML = `
          <div style="padding-left: 8px">
            ${date.name}
            </div>
          `;
        }
      }
    }
  };

  const handleDateClick = (info) => {
    // block if doing something
    if (_showProgress === true) {
      return;
    }

    const dateStr = info.dateStr;
    handleClick(dateStr);
  };

  const handleEventClick = (info) => {
    // block if doing something
    if (_showProgress === true) {
      return;
    }

    const event = info.event;
    const dateStr = event.startStr;
    handleClick(dateStr);
  };

  const isPastDaysAhead = (dateStr) => {
    // compare as string for hard date first
    if (!isStringEmpty(_status.selectCutoffDate)) {
      return dateStr > _status.selectCutoffDate;
    }

    if (_status.selectDaysAhead === "" || _status.selectDaysAhead === null) {
      return false;
    }

    // check days ahead
    let dDate = parseYYYYMMDD(dateStr);
    let dSelectCutoffDate = dayjs().add(_status.selectDaysAhead, "d");

    let days = getDifferenceInDays(dSelectCutoffDate, dDate);

    // days will be negative if before value
    return days > _status.selectDaysAhead;
  };

  const clearAllPeriodActivities = () => {
    setAllPeriodActivities({
      period1: [],
      period2: [],
      period3: [],
      period4: [],
      period5: [],
      period6: [],
      period7: [],
      period8: [],
      period9: [],
      period10: [],
      period11: [],
      period12: [],
      period13: [],
      period14: [],
      period15: [],
      period16: [],
      period17: [],
      period18: [],
      period19: [],
      period20: [],
    });
  };

  const handleClick = async (targetDateStr) => {
    const currentDateStr = getToday();
    const mTargetDate = dayjs(targetDateStr);

    if (targetDateStr < currentDateStr) {
      showError("Unable to Sign Up", "Date has already passed by.");
      return;
    }

    if (isDisabledDate(targetDateStr)) {
      showError("Unable to Sign Up", "Date is disabled.");
      return;
    }

    if (isPastDaysAhead(targetDateStr)) {
      showError(
        "Unable to Sign Up",
        "You cannot sign up that far ahead (school policy).",
      );
      return;
    }

    // same date?  check time
    if (targetDateStr === currentDateStr) {
      // if date is current date then check time
      const currentTime = parseInt(dayjs().format("HHmm"));
      const cutoffTime = _status.activityCutoffTime;

      if (currentTime > parseInt(cutoffTime)) {
        showError(
          "Unable to update Date",
          "Activity Cutoff Time has been exceeded.",
        );
        return;
      }
    }

    setDialogDate(getMD(mTargetDate) + " (" + getDay(mTargetDate) + ")");

    setBackDropOpen(true);
    setShowProgress(true);
    setSelectedCategoryEid("XX");
    clearAllPeriodActivities();

    let promises = [
      getDateActivities(_school, _jwt, targetDateStr),
      getDayForStudent(_school, _jwt, targetDateStr),
    ];

    Promise.all(promises)
      .then((results) => {
        const sortedActivityData = sortActivitiesWithZeroAtBottom(results[0].data);

        setAllPeriodActivities(sortedActivityData);
        setFilteredPeriodActivities(sortedActivityData);
        setDayActivityCount(sortedActivityData.dayPeriodCount);

        // store loaded dates for future reference
        const loadedDates = clone(_loadedDates);
        loadedDates[targetDateStr] = sortedActivityData;
        setLoadedDates(loadedDates);

        loadStudentSelectedActivities(results[1].data.activities);
        setMSelectedDate(mTargetDate);
        setBackDropOpen(false);
        setDialogOpen(true);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const loadStudentSelectedActivities = (activities) => {
    const selectedActivities = clone(_selectedActivities);

    // just append ADids
    let originalActivityHash = "";

    for (
      let periodNum = 1;
      periodNum <= _school.maxActivityCount;
      periodNum++
    ) {
      const key = `period${periodNum}`;
      let value = getEmptySelectedActivity();

      // initialize value
      selectedActivities[key] = value;

      // if key set then get value
      if (key in activities) {
        _selectedActivities[key] = activities[key];
        value = getSelectedActivityFromResult(activities, periodNum);
        if (value == null) {
          value = getEmptySelectedActivity();
        }
      }
      selectedActivities[key] = value;
      originalActivityHash += value.activityDateEid + "|";
    }

    setOriginalActivityHash(originalActivityHash);
    setSelectedActivities(selectedActivities);
    setOriginalSelectedActivities(clone(selectedActivities));
  };

  const handleDetailDialogClose = () => {
    setDetailDialogOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const getActivityEntry = (periodNum, activityDateEid) => {
    // used to account for differing days of activity counts
    if (_allPeriodActivities[`period${periodNum}`] == null) {
      return null;
    }

    for (let a of _allPeriodActivities[`period${periodNum}`]) {
      if (activityDateEid === a.activityDateEid) {
        return a;
      }
    }

    return null;
  };

  const getOriginalSelectedActivityEntry = (periodNum) => {
    return _originalSelectedActivities[`period${periodNum}`];
  };

  const handleDialogSave = () => {
    // this.activityService
    const values = {
      date: getYYYYMMDD(_mSelectedDate),
      attendanceType: "I",
    };
    let proposedActivityHash = "";

    // loop number of periods for today
    for (let periodNum = 1; periodNum <= _dayActivityCount; periodNum++) {
      // key: value
      let selectedActivity = _selectedActivities[`period${periodNum}`];
      let activityDateEid = selectedActivity.activityDateEid;

      let activityDetails = getActivityEntry(periodNum, activityDateEid);
      proposedActivityHash += activityDateEid + "|";

      // if already maxxed out then show message;
      // see if the activity has been changed from original selections
      let originalSelectedActivity =
        getOriginalSelectedActivityEntry(periodNum);

      let originalSelectedActivityDateEid = null;
      let selectedActivityDateEid = null;

      if (originalSelectedActivity != null) {
        originalSelectedActivityDateEid =
          originalSelectedActivity.activityDateEid;
      }
      if (activityDetails != null) {
        selectedActivityDateEid = activityDetails.activityDateEid;
      }

      // if there was a change then see if its maxxed out
      if (originalSelectedActivityDateEid !== selectedActivityDateEid) {
        if (activityDetails != null && activityDetails.left === 0) {
          alert(
            `For ${getPeriodName(_school, periodNum - 1)}, "${
              activityDetails.name
            }" is MAXXED OUT.  Please select another activity.`,
          );
          return;
        }
      }

      if (activityDateEid === "XX") {
        activityDateEid = "";
      }

      // assign the activity date eid
      values[`mav${periodNum}`] = activityDateEid;
      values[`mavreason${periodNum}`] = "";
      values[`mavnotmodify${periodNum}`] = false;
      values[`mavcomment${periodNum}`] = "";
      values[`favorite${periodNum}`] = false;
    }

    // user clicked save but didn't change any activities, so just close dialog and return
    if (proposedActivityHash === _originalActivityHash) {
      // bail, but communicate that no changes were made
      showToast("S", `Saved for ${getMMDD(_mSelectedDate)}.`);
      setDialogOpen(false);
      return;
    }

    setShowProgress(true);
    saveStudentDay(_school, _jwt, values)
      .then((result) => {
        // old service
        // if (!isStringEmpty(result.data.message)) {
        //   showError("Unable to Save Activity", result.data.message);
        //   return;
        // }

        if (!isStringEmpty(result.data)) {
          let message = "" + result.data;
          message = message.trim();
          showError("Unable to Save Activity", message);
          return;
        }

        // new service
        console.log(result.detail)
        if (result.detail) {
          alert("Unable to Save Activity: " + result.detail);
          return;
        }

        if (result.detail) {
          alert("Unable to Save Activity: " + result.detail);
          return;
        }

        showToast("S", `Activities Saved for ${getMMDD(_mSelectedDate)}.`);
        setDialogOpen(false);

        // update student calendar with items added/removed
        return updateCalendarEvents(values);
        // .then((result) => {
        //   loadDateEvents(result.data, _disabledDaysMap);
        // })
      })
      .catch((error) => {
        console.log(error);
        showToast(
          "E",
          "Unable to Save Activities for " + getYYYYMMDD(_mSelectedDate) + ".",
        );
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const handleChangeSelectedActivity = (value, periodNum) => {
    // scrape out mav and get the period number

    // clone and set
    const selectedActivities = clone(_selectedActivities);
    selectedActivities[`period${periodNum}`] = { activityDateEid: value };
    setSelectedActivities(selectedActivities);
  };

  const handleDetailClick = (activity, periodNum) => {
    if (activity.activityDateEid === "XX") {
      window.showAlert("Unable to Show Detail", "Please select an activity.");
      return;
    }

    // if there's no ID on the activity object, then the student has casually selected
    // an activity, but has not clicked the "Sign up" button yet.  We need to get the info about the activity from another source.
    setDetailActivityPeriod(periodNum);
    if (activity.id != null) {
      setDetailActivity(activity);
    } else {
      for (let a of _allPeriodActivities[`period${periodNum}`]) {
        if (activity.activityDateEid === a.activityDateEid) {
          setDetailActivity(a);
          break;
        }
      }
    }

    setDetailDialogOpen(true);
  };

  const getSelectedCategory = (eid) => {
    for (let category of _categories) {
      if (category.eid === eid) {
        return category;
      }
    }
    return null;
  };

  const getSelectedTag = (eid) => {
    for (let tag of _tags) {
      if (tag.eid === eid) {
        return tag;
      }
    }
    return null;
  };

  const filterByCategory = (categoryEid, category) => {
    // TODO FIX WITH PERIOD KEYS, THEN THE ACTIVITIES
    const filteredActivities = initFilteredActivityBuckets();

    // create the buckets for the the number of periods being shown for filtration
    let periodCount = Object.keys(filteredActivities).length;

    // perform the filtration, for every period for the day
    for (let i = 1; i <= periodCount; i++) {
      const periodKey = `period${i}`;

      // loop each period
      for (let activity of _allPeriodActivities[periodKey]) {
        // add if "all categories is selected"
        // OR category ID matches activity id
        if (
          categoryEid === "XX" ||
          (category != null && category.id === activity.categoryId)
        ) {
          filteredActivities[periodKey].push(activity);
        } else {
          // OR there's a preselected activity id (regardless of category)
          if (
            _selectedActivities[periodKey].activityDateEid ==
            activity.activityDateEid
          ) {
            filteredActivities[periodKey].push(activity);
          }
        }
      }
    }

    const sortedActivityData = sortActivitiesWithZeroAtBottom(filteredActivities);
    setFilteredPeriodActivities(sortedActivityData);
  };

  const handleChangeCategory = (event) => {
    let categoryEid = "XX";
    if (event != null) {
      categoryEid = event.target.value;
    }
    setSelectedCategoryEid(categoryEid);

    const category = getSelectedCategory(categoryEid);

    // pass both, in case category is null (e.g. 'XX')
    filterByCategory(categoryEid, category);
  };

  const getHiddenDays = () => {
    let days = [0, 6];

    if (_school && _school.hiddenDays) {
      const arry = [];
      for (let i = 0; i < _school.hiddenDays.length; i++) {
        arry.push(parseInt(_school.hiddenDays[i]));
      }
      days = arry;
    }

    return days;
  };

  const isSignupButtonDisabled = () => {
    // _selectedActivities["period" + (i + 1)].modify === 0
    // if all drop boxes are disabled then return true

    let modifyCount = 0;
    for (const [key, a] of Object.entries(_selectedActivities)) {
      if (a.modify === 0) {
        modifyCount++;
      }
    }

    if (modifyCount >= _school.maxActivityCount) {
      return true;
    }

    return false;
  };

  const getDisabledDate = (dateStr) => {
    return _disabledDaysMap[dateStr];
  };

  const isDisabledDate = (dateStr) => {
    // if specified date is disabled then disable
    return getDisabledDate(dateStr) != null;
  };

  // user for filtering categories and tags
  const initFilteredActivityBuckets = () => {
    const filteredActivities = {};
    // create the buckets for the the number of periods being shown for filtration
    for (let i = 1; i <= MAX_ACTIVITY_COUNT; i++) {
      const key = `period${i}`;

      // stop looping once we hit the max number of activities
      if (_allPeriodActivities[key] == null) {
        break;
      }

      // assign the key
      filteredActivities[key] = [];
    }
    return filteredActivities;
  };

  const hasActivityTag = (tagEid, activity) => {
    if (activity.tags === "{}") {
      return false;
    }

    const activityTagJson = JSON.parse(activity.tags);
    const eids = activityTagJson.eids;

    for (let eid of eids) {
      if (eid === tagEid) {
        return true;
      }
    }

    return false;
  };

  const filterByTag = (tagEid, tagObj) => {
    // TODO FIX WITH PERIOD KEYS, THEN THE ACTIVITIES
    const filteredActivities = initFilteredActivityBuckets();

    // create the buckets for the the number of periods being shown for filtration
    let periodCount = Object.keys(filteredActivities).length;

    // perform the filtration, for every period for the day
    for (let i = 1; i <= periodCount; i++) {
      const periodKey = `period${i}`;

      // loop each period
      for (let activity of _allPeriodActivities[periodKey]) {
        // add if "all categories is selected"
        // OR category ID matches activity id
        if (
          tagEid === "XX" ||
          (tagObj != null && hasActivityTag(tagObj.eid, activity))
        ) {
          filteredActivities[periodKey].push(activity);
        } else {
          // OR there's a preselected activity id (regardless of category)
          if (
            _selectedActivities[periodKey].activityDateEid ==
            activity.activityDateEid
          ) {
            filteredActivities[periodKey].push(activity);
          }
        }
      }
    }

    const sortedActivityData = sortActivitiesWithZeroAtBottom(filteredActivities);
    setFilteredPeriodActivities(sortedActivityData);
  };

  const handleChangeTag = (event) => {
    let tagEid = "XX";
    if (event != null) {
      tagEid = event.target.value;
    }
    setSelectedTagEid(tagEid);

    const tagObj = getSelectedTag(tagEid);

    // // pass both, in case category is null (e.g. 'XX')
    filterByTag(tagEid, tagObj);
  };

  const getActivityName = (ad) => {
    const activityNameJson = JSON.parse(_schoolStatus.activityNameFormat);
    let name = "";

    for (const field of activityNameJson.fields) {
      switch (field) {
        case "{locationName}":
          name += ad.location + " ";
          break;
        case "{hyphen1}":
        case "{hyphen2}":
        case "{hyphen3}":
          name += " - ";
          break;
        case "{comma1}":
        case "{comma2}":
        case "{comma3}":
          name += ", ";
          break;
        case "{colon1}":
        case "{colon2}":
        case "{colon3}":
          name += ": ";
          break;
        case "{teacherLastName}":
        case "{teacherFirstName}":
          name += ad.last_name + " " + ad.first_name.charAt(0) + " ";
          break;
        case "{activityName}":
          name += ad.name + " ";
          break;
        case "{remainingSeats}":
          if (ad.left === 0) {
            name += " (MAXXED OUT)";
          } else {
            name += `(${ad.left} left) `;
          }
          break;
      }
    }

    return name;
  };

  return (
    <>
      <DrawerAppBar />

      <Container>
        <Title text="Click Date to Sign Up" showBack={true} />
        <ProgressBar showProgress={_showProgress} />
        <Alert severity="info" key={alert.title} sx={{ mb: 2 }}>
          Cutoff Time is {_cutoffTimeText}.
        </Alert>

        <FullCalendar
          ref={calendarRef}
          initialView="dayGridMonth"
          locale="en"
          dateClick={(info) => handleDateClick(info)}
          eventClick={(info) => handleEventClick(info)}
          headerToolbar={{
            start: "title",
            center: "listWeek,dayGridMonth",
            end: "prev,next,refreshButton",
          }}
          customButtons={{
            refreshButton: {
              text: "↻",
              click: () => {
                initContent();
              },
              ariaLabel: "reload",
            },
          }}
          aspectRatio={_calendarRatio}
          hiddenDays={getHiddenDays()}
          plugins={[interactionPlugin, dayGridPlugin, listPlugin]}
          events={_calendarEvents}
          height={"500px"}
          themeSystem="standard"
        />

        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={_backDropOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Container>

      <Dialog fullWidth open={_dialogOpen} onClose={handleDialogClose}>
        <DialogTitle sx={{ p: 1 }}>For {_dialogDate}: </DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          {_school.groupStudentActivities === "Y" && _school.studentShowCategory === "Y" && (
            <>
              <Grid container spacing={1}>
                <Grid item xs={_tags.length > 0 ? 6 : 12} sx={{ pr: 0 }}>
                  <strong
                    style={{ marginBottom: "10px", marginLeft: "-0.5em" }}
                  >
                    Category:
                  </strong>
                  <Select
                    onChange={(event) => handleChangeCategory(event)}
                    value={_selectedCategoryEid}
                    sx={{ mb: 0, ml: -1 }}
                    fullWidth
                    size="small"
                  >
                    <MenuItem key="XX" value="XX">
                      -- ANY --
                    </MenuItem>
                    {_categories.map((category) => (
                      <MenuItem key={category.eid} value={category.eid}>
                        {category.name}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                {_tags.length > 0 && (
                  <Grid item xs={6} sx={{ pr: 0 }}>
                    <>
                      <strong
                        style={{ marginBottom: "10px", marginLeft: "-0.5em" }}
                      >
                        Tag:
                      </strong>
                      <Select
                        onChange={(event) => handleChangeTag(event)}
                        value={_selectedTagEid}
                        sx={{ mb: 0, ml: -1 }}
                        fullWidth
                        size="small"
                      >
                        <MenuItem key="XX" value="XX">
                          -- ANY --
                        </MenuItem>
                        {_tags.map((tag) => (
                          <MenuItem key={tag.eid} value={tag.eid}>
                            {tag.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </>
                  </Grid>
                )}
              </Grid>

              <br />
              <br />
            </>
          )}

          {_school.maxActivityCount < 10 && (
            <>
              {[...Array(_dayActivityCount)].map((x, i) => (
                <>
                  {/* needed for dates that have variable activity counts */}
                  {_filteredPeriodActivities["period" + (i + 1)] != null &&
                    _selectedActivities["period" + (i + 1)] != null && (
                      <Grid
                        key={"pg" + i}
                        container
                        sx={{ ml: -2, mb: 1, mt: -1 }}
                        spacing={1}
                      >
                        <Grid item xs={10} sx={{ pr: 0 }}>
                          <strong>{getPeriodName(_school, i)}:</strong>
                          <br />
                          <Select
                            id={"mav" + (i + 1)}
                            onChange={(event) =>
                              handleChangeSelectedActivity(
                                event.target.value,
                                i + 1,
                              )
                            }
                            value={
                              _selectedActivities["period" + (i + 1)]
                                .activityDateEid
                            }
                            sx={{ mb: 1 }}
                            fullWidth
                            disabled={
                              _selectedActivities["period" + (i + 1)].modify ===
                              0
                            }
                            size="small"
                          >
                            <MenuItem key="XX" value="XX">
                              -- NO ACTIVITY SELECTED --
                            </MenuItem>
                            {_filteredPeriodActivities["period" + (i + 1)].map(
                              (activity) => (
                                <MenuItem
                                  key={activity.activityDateEid}
                                  value={activity.activityDateEid}
                                >
                                  {getActivityName(activity)}
                                </MenuItem>
                              ),
                            )}
                          </Select>
                        </Grid>
                        <Grid item xs={2}>
                          <br />
                          <Button
                            variant="contained"
                            className="button2"
                            title="additional activity details"
                            onClick={() => {
                              handleDetailClick(
                                _selectedActivities["period" + (i + 1)],
                                i + 1,
                              );
                            }}
                          >
                            ...
                          </Button>
                        </Grid>
                      </Grid>
                    )}
                </>
              ))}
            </>
          )}

          {_school.maxActivityCount >= 10 && <>gt 10</>}
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleDialogClose}>
            Cancel
          </Button>
          <LoadingButton
            sx={{ width: 120 }}
            onClick={handleDialogSave}
            loading={_showProgress}
            variant="contained"
            disabled={isSignupButtonDisabled()}
          >
            Sign Up
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth={true}
        open={_detailDialogOpen}
        onClose={handleDetailDialogClose}
      >
        <DialogTitle sx={{ p: 1 }}>Activity Details</DialogTitle>
        <DialogContent sx={{ pb: 0 }}>
          <List sx={{ width: "100%" }}>
            <PeriodListItem
              school={_school}
              periodNumber={_detailActivityPeriod}
              period={_detailActivity}
            />
          </List>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleDetailDialogClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Signup;
